"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyModel = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../../utils/constants");
var _Types = require("../../../Types");
const _excluded = ["args", "onPointerOver", "onClick", "onPointerMissed", "onPointerOut"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const EmptyModel = _ref => {
  let {
      args,
      onPointerOver,
      onClick,
      onPointerMissed,
      onPointerOut
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const shadows = {
    castShadow: true,
    receiveShadow: true
  };
  return /*#__PURE__*/_react.default.createElement("group", _extends({
    dispose: null,
    visible: true
  }, props), /*#__PURE__*/_react.default.createElement("mesh", {
    position: [0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement("boxGeometry", {
    args: [40, 40, 40]
  }), /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: "#FF0000",
    transparent: "true",
    opacity: ".0",
    alphaTest: true
  })), /*#__PURE__*/_react.default.createElement("group", {
    onPointerOver: onPointerOver,
    onClick: onClick,
    onPointerMissed: onPointerMissed,
    onPointerOut: onPointerOut
  }, /*#__PURE__*/_react.default.createElement("mesh", shadows, /*#__PURE__*/_react.default.createElement("boxGeometry", {
    args: args || [5, 5, 5]
  }), /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    wireframe: true,
    color: _constants.pipesColor.disabled
  }))));
};
exports.EmptyModel = EmptyModel;
EmptyModel.propTypes = {
  args: _Types.VectorType,
  onPointerOver: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onPointerMissed: _propTypes.default.func,
  onPointerOut: _propTypes.default.func
};